import { Header, Row, Col, Content, Loader, Grid } from 'rsuite';

import React, {useState, useEffect} from 'react';
import logo from '../assets/svg/logo.svg'
import Card from "../components/Card.component"
import { Link } from 'react-router-dom';
import UserService from '../services/User.service';

function KycExternoPage(props) {
    const hash = window.location.hash;
    const [route, queryString] = hash.split('?'); 
    const params = new URLSearchParams(queryString);
    const user_id = params.get('user');    // "abc123"
    const token = params.get('token');    // "TOKEN"

    const userService = new UserService();

    const [isMobile, setIsMobile] = useState(false);

    const [kyc, setKyc]  = useState({});

    const checkKyc = async (userID) => {
        try {
            const kycResponse = await userService.post({ user_id: user_id, token: token },"user/generate/kyc/externo");

            if (kycResponse) {
                setKyc(kycResponse);
            } 
        } catch (error) {
            console.error("Erro ao buscar KYC:", error);
        }
    };

    useEffect(() => {
        checkKyc(user_id)
        const checkIsMobile = () => setIsMobile(window.innerWidth <= 768);

        checkIsMobile(); // Verifica ao carregar
        window.addEventListener("resize", checkIsMobile); // Atualiza se a janela for redimensionada

        if (window.innerWidth <= 768 && kyc?.url) {
            window.location.href = kyc.url;
        }

        return () => window.removeEventListener("resize", checkIsMobile);
    }, [user_id]);

    return (
        <Grid fluid>
            <Row>
                 <Row>
                    <Col className="blue-panel" style={{height: '40vh', position: 'inherit', display: 'flex', justifyContent: 'center'}} xs={24} md={24}>
                        <img className="svg-image-recovery-passwd" src={logo} alt="Ecom pay" width={'120px'} />
                    </Col>
                </Row>
                <Row style={{display: 'flex', justifyContent: 'center'}}>
                    <Col xs={22} md={8} className="card-position-recovery-passwd">
                        <Card style={{minHeight: '500px', padding: '5% 5%'}}>
                            {
                                !kyc.base64_qrcode ? 
                                    <>
                                        <Row style={{display: "flex", justifyContent: "center"}}>
                                            <Row style={{ width: "200px", height: "240px", display: "flex", alignItems: "center", justifyContent: "center"}}>
                                                <Loader 
                                                    content="Carregando..." 
                                                    vertical 
                                                    size="md"    
                                                />
                                            </Row>
                                        </Row> 
                                    </>:
                                    <>
                                        <Row 
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center', 
                                                alignItems: 'center',
                                                marginTop: "20px"
                                            }}
                                        >
                                            <span className="label">
                                                📷 Para validar sua identidade, escaneie o QR Code 
                                                abaixo usando seu celular. Você será direcionado para 
                                                a verificação de selfie e documentos.
                                            </span>
                                        </Row>
                                        <Row 
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center', 
                                                alignItems: 'center',
                                                marginTop: "50px"
                                            }}
                                        >
                                            <img 
                                                alt="Qrcode" 
                                                src={`data:image/svg+xml;base64,${kyc.base64_qrcode}`} 
                                                style={{ width: "300px", height: "300px" }}
                                            />
                                        </Row>
                                    </>
                            }
                        </Card>
                    </Col>
                </Row>
            </Row>
        </Grid>
    )
}

export default KycExternoPage;
